import { Box } from '@mui/material'
import { carrierVisitViewStatus, CarrierVisitViewStatus } from '@planning/constants'
import { useTranslate } from '@tolgee/react'
import { ColoredLabel, ColorSchema, useMinimalsTheme } from '@tom-ui/ui'
import { FC } from 'react'

type Props = {
  status: CarrierVisitViewStatus
  isBerthed?: boolean
}

export const CarrierVisitStatusChip: FC<Props> = props => {
  const { status, isBerthed } = props
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  const colorMap: Record<CarrierVisitViewStatus, ColorSchema> = {
    [CarrierVisitViewStatus.Expected]: 'info',
    [CarrierVisitViewStatus.Arrived]: 'primary',
    [CarrierVisitViewStatus.Berthed]: 'primary',
    [CarrierVisitViewStatus.InOperation]: 'busy',
    [CarrierVisitViewStatus.OperationCompleted]: 'primary',
    [CarrierVisitViewStatus.Completed]: 'primary',
    [CarrierVisitViewStatus.Departed]: 'primary',
    [CarrierVisitViewStatus.Closed]: 'secondary',
    [CarrierVisitViewStatus.Cancelled]: 'secondary',
  }

  const color = colorMap[status] ?? 'secondary'

  let backgroundColor: string

  if (status === CarrierVisitViewStatus.Cancelled) {
    backgroundColor = theme.palette.grey[300]
  } else if (status === CarrierVisitViewStatus.Closed) {
    backgroundColor = theme.palette.grey[200]
  } else {
    backgroundColor = theme.palette[color].lighter
  }

  const label =
    status === CarrierVisitViewStatus.Arrived && isBerthed
      ? 'Berthed'
      : carrierVisitViewStatus.find(cvs => cvs.id === status)?.value ?? status

  return (
    <Box data-cy='carrier-visit-status-chip'>
      <ColoredLabel
        label={t(label)}
        color={color}
        sx={{
          width: 'fit-content',
          backgroundColor,
        }}
      />
    </Box>
  )
}
